import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import { Col, Typography, Row, Card, Button, Modal, message, notification, Spin, Layout } from 'antd';
import styled, { keyframes, css } from 'styled-components';
import { EditorState, convertToRaw, ContentState } from 'draft-js';
import ReactPlayer from 'react-player';
import RecordRTC, { StereoAudioRecorder } from 'recordrtc';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { Editor } from 'react-draft-wysiwyg';
import htmlToDraft from 'html-to-draftjs';
import * as diff_match_patch from 'diff-match-patch';
import { LoadingOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { captureUserMedia, getCurrentUserLessonIdx, parseLessonCode } from 'src/utils';
import { isMobileOnly } from 'react-device-detect';
import { ImgButton } from 'src/components/Header/toolHeaderstyle';
import { useHistory } from 'react-router-dom';
import FullScreenButton from 'src/components/common/FullScreenButton';
import { createRecordingObjectUrl, processKaldiSttWithRetry } from 'src/utils/recordingNetwork';
const { Header: HeaderWrapper } = Layout;
const dmp = new diff_match_patch();
const { Title } = Typography;
const antIcon = <LoadingOutlined style={{ fontSize: 30, color: '#fff', lineHeight: '35px' }} spin />;
const MainBlock = styled.div`
  padding: 10px;
  margin-top: 10px;
  background: #fff;
  height: calc(100vh - 94px);
  display: flex;
`;

const TotalBox = styled.span`
  color: rgb(255, 122, 27);
  border: 1px solid #6b5c5c;
  padding: 5px 10px;
  border-radius: 5px;
`;

const ScoreBox = styled.span`
  color: #de3333;
  border: 1px solid #de3333ab;
  padding: 5px 10px;
  border-radius: 5px;
`;

const WpmPage = ({ onClickGoback, data = [], code, userData, hideHeader }) => {
  let width = useCheckScreen()[0];
  let height = useCheckScreen()[1];
  // const userData = getUserInfo();
  const [text, setText] = useState(EditorState.createEmpty());
  const [textRest, setTextResp] = useState(EditorState.createEmpty());
  const [currentLesson, setCurrentLesson] = useState(code);
  const [currentLessonText, setCurrentLessonText] = useState([]);
  const [firstPageNo, setFirstPageNo] = useState(0);
  // const [isMobile, setIsMobile] = useState(useCheckMobileScreen());
  const [doneLessonText, setDoneLessonText] = useState([]);
  const [showLoading, setShowLoading] = useState(false);
  const [currentText, setCurrentText] = useState([]);
  const [lastText, setLastText] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [lastPage, setLastPage] = useState([]);
  const [startPageIndx, setStartPageIndx] = useState(-1);
  const [sttResp, setSttResp] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [imageSize, setImageSize] = useState('100%');
  const [currentRecLength, setCurrentRecLenght] = useState(0);
  const [isReadOnly, setIsReadOnly] = useState(false);
  const [isRecording, setIsRecording] = useState(false);
  const [isActive, setIsActive] = useState(true);
  const [recordingData, setRecordignData] = useState([]);
  const [totalPage, setTotalPage] = useState(0);
  const [playing, setPlaying] = useState(false);
  const [lastBlob, setLastBlob] = useState(null);
  const recordAudio = useRef(null);
  const recorderStreams = useRef(null);
  const recordingRequestId = useRef(0);
  const recordingRequested = useRef(false);
  const [blobChunks, setBlobChunks] = useState([]);
  const mainBlockRef = useRef(null);
  const currentSttRequest = useRef([]);
  const [isModalVisible, setIsModalVisible] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const currentSttText = useRef([]);
  const nextItemRef = useRef(null);
  const [RenderStageCompletePopup, setRenderStageCompletePopup] = useState(() => () => <div />);
  const [currentProgressSlider, setCurrentProgressSlider] = useState(0);
  const [currentDoneValue, setCurrentDoneValue] = useState(null);
  const [processCallbackLoading, setProcessCallbackLoading] = useState([]);
  const currentTextValue = currentText.map((e) => e.text).join('\n');
  const [apiSuccess, setApiSuccess] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const history = useHistory();
  const dataNew = useMemo(() => {
    if (data) {
      const formatedData = data.map((item, key) => {
        return {
          ...item,
          page: item.page_no,
        };
      });
      return formatedData;
    } else {
      return [];
    }
  }, [data]);
  useEffect(() => {
    if (dataNew.length > 0 && !apiSuccess) {
      setApiSuccess(true);
      let recData = dataNew.map((item, indx) => ({ ...item, page_no: indx, page: indx }));
      const recIndx = recData.reduce(function (acc, d, i) {
        if (parseInt(d.recording) === 1) {
          acc.push(i); // gather indexes per element
        }
        return acc;
      }, []);
      if (recIndx[recIndx.length - 1] === recData.length) {
        recData = recData.slice(recIndx[0]);
      } else {
        recData = recData.slice(recIndx[0], recIndx[recIndx.length - 1] + 1);
      }
      setTotalPage(recData.length);
      setFirstPageNo(recData[0]['page']);
      let donePages = window.localStorage.getItem(`PASSAGE_${code}_${userData.user_idx}`);
      donePages = donePages ? JSON.parse(donePages) : [];
      let startPageIndx = recData[0]['page'];
      let soneKeys = Object.keys(donePages);

      if (soneKeys.length) {
        startPageIndx = parseInt(soneKeys.pop());
        let tempData = [];
        donePages.forEach((e, i) => {
          if (e) tempData[i] = e;
        });
        currentSttText.current = tempData;
        message.info(` ${startPageIndx + 1} 페이지까지 학습 기록이 있습니다. 다음 페이지부터 이어서 학습하세요. `);
      }

      setStartPageIndx(startPageIndx);
      setRecordignData(recData);

      //   // if(![0,1].includes(data?.getRecordingStudyData[0]["page_no"])) message.info(`Goto page ${data?.getRecordingStudyData[0]["page_no"]}`);
    }
  }, [dataNew]);

  useEffect(() => {
    if (currentLesson && recordingData.length) {
      let phraseList = recordingData.filter((e) => parseInt(e.recording));
      phraseList = phraseList.map((e) => e.text);
      setCurrentLessonText(phraseList);
    }
  }, [recordingData, currentLesson, processCallbackLoading]);

  useEffect(() => {
    let donePages = window.localStorage.getItem(`PASSAGE_${code}_${userData.user_idx}`);
    donePages = donePages ? JSON.parse(donePages) : [];

    setCurrentDoneValue(donePages[currentPage]);
  }, [currentPage, processCallbackLoading]);

  const sleep = (m) => new Promise((r) => setTimeout(r, m));

  useEffect(() => {
    recordingRequested.current = isRecording;
    const requestId = ++recordingRequestId.current;

    if (isRecording) {
      setCurrentRecLenght(0);
      startRecord(currentPage, requestId);
    } else {
      if (recordAudio.current && recordAudio.current[currentPage]) {
        stopRecording(currentPage);
      } else {
        stopRecording(lastPage);
      }
    }
  }, [isRecording]);

  useEffect(
    () => () => {
      recordingRequested.current = false;
      recordingRequestId.current += 1;
      recorderStreams.current?.getTracks?.().forEach((track) => track.stop());
      recorderStreams.current = null;
    },
    [],
  );

  useEffect(() => {
    setIsRecording(false);
    if (apiSuccess) {
      setLastText(currentText);
      let phraseList = recordingData.filter((e) => currentPage == e.page);
      if (phraseList.length) {
        let recordginPage = phraseList.filter((e) => parseInt(e.recording));
        setCurrentText(recordginPage);
      } else if (onClickGoback && Object.values(currentSttText.current).length > 0 && recordingData.length) {
        const fitlerrec = recordingData.filter((p) => p.text);
        const allReqDone = Object.values(currentSttRequest.current).filter((p) => !p);
        if (!allReqDone.length) {
          let soneKeys = Object.keys(currentSttText.current).map((p) => parseInt(p));
          let filNotDone = fitlerrec.filter((r) => !soneKeys.includes(r.page_no));
          if (filNotDone.length) {
            Modal.destroyAll();
            Modal.error({
              icon: null,
              title: 'Not Complete',
              content: (
                <Title level={4}>
                  {`  학습이 완료되지 않았습니다.`}
                  <br />
                  {`${filNotDone.map((p) => p.page_no).join(',')} 페이지를 확인하세요.`}
                </Title>
              ),
            });
          } else {
            window.localStorage.removeItem(`PASSAGE_${code}_${userData.user_idx}`);
            const cSttText = Object.values(currentSttText.current);
            const accuracy = parseInt(cSttText.reduce((p, t) => p + t.accuracy, 0) / cSttText.length);
            const wpm = parseInt(cSttText.reduce((p, t) => p + t.wpm, 0) / cSttText.length);
            Modal.destroyAll();
            Modal.info({
              icon: null,
              title: 'Done',
              content: <Title level={4}>{`  당신의 점수는 ${accuracy} 점 입니다. 학습을 종료합니다.`}</Title>,
              onOk: () => {
                onClickGoback(
                  {
                    exam_total: 100,
                    exam_correct: accuracy,
                    message: `당신의 점수는 ${accuracy} 점 입니다. 학습을 종료합니다.`,
                    exitMessage: `학습을 종료하시겠습니까?`,
                    recording_data: cSttText.map((e) => `<p>${e.text}</p>`).join(''),
                    wpm,
                  },
                  true,
                );
              },
            });
          }
        } else if (!showLoading) {
          setShowLoading(true);
        }
      } else {
        setCurrentText([]);
      }
    }
  }, [currentPage, startPageIndx, showLoading, apiSuccess]);
  const openModel = () => {
    let filteredTexts = [dataNew[currentPage]['text'].replace(/\n/g, '<br/>')].filter((f) => f !== '' && f);
    const { contentBlocks, entityMap } = htmlToDraft(filteredTexts.map((e) => `<p>${e}</p>`).join());
    const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
    setText(EditorState.createWithContent(contentState));

    const cb2 = htmlToDraft(
      Object.values(currentDoneValue ? [currentDoneValue] : [])
        .map((e) => `<p>${e.text}</p>`)
        .join(),
    );
    const contentState2 = ContentState.createFromBlockArray(cb2.contentBlocks, cb2.entityMap);
    setTextResp(EditorState.createWithContent(contentState2));

    setShowModal(true);
    hideHeader(true);
  };
  const processRecordCallback = useCallback(
    async (blob, textA, currentRecLength, page) => {
      let fd = new FormData();
      let text = textA.map((p) => p);
      text.push('[unk]');
      fd.append('audio', blob);
      fd.append('sample_rate', 16000);
      currentSttRequest.current[page] = false;

      let sanitizePhraseList = text.map((e) =>
        e.replace(/[\u2010-\u2015\u2212]/g, ' ').replace(/[.,?!’“”]/gi, '').toLowerCase(),
      );
      fd.append('phrase_list', JSON.stringify(sanitizePhraseList));

      processCallbackLoading[page] = true;
      setProcessCallbackLoading(JSON.parse(JSON.stringify(processCallbackLoading)));

      const resData = await processKaldiSttWithRetry(fd);
      processCallbackLoading[page] = false;
      setProcessCallbackLoading(JSON.parse(JSON.stringify(processCallbackLoading)));

      let prev = currentSttText.current;

      let phList = sanitizePhraseList.reduce((p, n) => p.concat(n.split(' ')), []).filter((p) => p != '');
      let dataSplit = resData.text.split(' ');
      resData.text = resData.text.replace('[unk]', '');

      // const filteredArray = phList.filter(value => dataSplit.includes(value));
      dmp.Diff_Timeout = 5;
      dmp.Diff_EditCost = 5;
      resData['accuracy'] = 0;
      resData['duration'] = currentRecLength;
      resData['wpm'] = currentRecLength > 0 ? (dataSplit.length / (currentRecLength / 1000)) * 60 : 0;
      const d = dmp.diff_main(
        textA
          .map((e) =>
            e
              .replace(/[\u2010-\u2015\u2212]/g, ' ')
              .replace(/[.,?!’“”]/gi, '')
              .replace(',', ' ')
              .toLowerCase(),
          )
          .reduce((p, n) => p + n, ''),
        resData.text,
      );
      dmp.diff_cleanupSemantic(d);
      let htmltext = [];
      d.forEach((element, i) => {
        if (element[0] === 0) {
          const filteredArrayl = element[1].split(' ').filter((value) => phList.includes(value));
          resData['accuracy'] += filteredArrayl.length;
          htmltext.push(`<span style="color:black;">${element[1]}</span>`);
        } else if (element[0] === -1) {
          const filteredArrayl = element[1].split(' ').filter((value) => phList.includes(value));
          resData['accuracy'] = resData['accuracy'] ? resData['accuracy'] - filteredArrayl.length / 6 : 0;
          htmltext.push(`<span style="color:brown; text-decoration:line-through;">${element[1]}</span>`);
        } else if (element[0] === 1) {
          htmltext.push(`<span style="color:darkblue;">${element[1]}</span>`);
        }
      });
      let tempAccuracy = phList.length > 0 ? resData['accuracy'] / (phList.length / 100) : 0;
      resData['accuracy'] = tempAccuracy > 0 ? tempAccuracy : 0;
      resData.text = htmltext.join('');
      prev[page] = resData;

      currentSttRequest.current[page] = true;
      window.localStorage.setItem(`PASSAGE_${code}_${userData.user_idx}`, JSON.stringify(prev));
      setShowLoading(false);

      currentSttText.current = prev;
      notification.success({ message: '저장되었습니다.', placement: 'topRight' });
    },
    [currentSttRequest],
  );

  const stopRecording = (page) => {
    if (recordAudio.current != null && recordAudio.current[page]) {
      // message.info('Recording Stopped');
      recordAudio.current[page].stopRecording(async () => {
        setIsLoading(true);
        setDoneLessonText((prev) => {
          let temp = prev.concat(currentLessonText);
          return temp;
        });
        const recorder = recordAudio.current[page];
        const recordedBlob = recorder.getBlob();
        void processRecordCallback(
          recordedBlob,
          currentText.map((e) => e.text),
          currentRecLength,
          page,
        )
          .catch((error) => {
            currentSttRequest.current[page] = false;
            processCallbackLoading[page] = false;
            setProcessCallbackLoading(JSON.parse(JSON.stringify(processCallbackLoading)));
            setShowLoading(false);
            console.error('Recording processing failed', error);
            message.error('Recording processing failed. Please check your network and try again.');
          })
          .then(() => setIsLoading(false));
        const previewUrl = createRecordingObjectUrl(recordedBlob);
        if (previewUrl) setLastBlob(previewUrl);
        recorder.destroy();
        recordAudio.current[page] = null;
        if (recorderStreams.current) {
          recorderStreams.current.getTracks().forEach((track) => track.stop());
          recorderStreams.current = null;
        }
      });
    }
  };

  const onDataAvailableCallback = useCallback(async (blob) => {
    setImageSize(100 - Math.floor(Math.random() * 10 + 1) + '%');

    setCurrentRecLenght((prev) => prev + 100);
    blob = await new Response(blob).arrayBuffer();

    setBlobChunks((prev) => {
      prev.push(blob);
      return prev;
    });
  }, []);

  const startRecord = (page, requestId) => {
    if (!isActive) return;
    captureUserMedia({ audio: { echoCancellation: true } }, async (stream) => {
      if (!recordingRequested.current || recordingRequestId.current !== requestId) {
        stream.getTracks().forEach((track) => track.stop());
        return;
      }

      if (!recordAudio.current) recordAudio.current = [];
      recorderStreams.current = stream;
      recordAudio.current[page] = RecordRTC(stream, {
        type: 'audio',
        mimeType: 'audio/wav',
        sampleRate: 48000,
        desiredSampRate: 16000,

        recorderType: StereoAudioRecorder,
        numberOfAudioChannels: 1,

        //1)
        // get intervals based blobs
        // value in milliseconds
        // as you might not want to make detect calls every seconds
        timeSlice: 100,

        // 2)
        // as soon as the stream is available
        ondataavailable: onDataAvailableCallback,
      });
      setBlobChunks([]);
      setLastBlob(null);
      recordAudio.current[page].startRecording();

      await sleep(500);
      if (
        !recordingRequested.current ||
        recordingRequestId.current !== requestId ||
        !recordAudio.current?.[page]
      ) {
        return;
      }
      message.info('Recording Started');
    }, () => {
      if (recordingRequestId.current !== requestId) return;
      recordingRequested.current = false;
      recordingRequestId.current += 1;
      setIsRecording(false);
    });
  };

  const pageMove = (page) => {
    setCurrentPage(page);
  };
  const handleUploadClick = () => {
    const fitlerrec = recordingData.filter((p) => p.text);
    const allReqDone = Object.values(currentSttRequest.current).filter((p) => !p);
    if (!allReqDone.length) {
      let soneKeys = Object.keys(currentSttText.current).map((p) => parseInt(p));
      let filNotDone = fitlerrec.filter((r) => !soneKeys.includes(r.page_no));
      if (filNotDone.length) {
        Modal.destroyAll();
        Modal.error({
          icon: null,
          title: 'Not Complete',
          content: (
            <Title level={4}>
              {`  학습이 완료되지 않았습니다.`}
              <br />
              {`${filNotDone.map((p) => p.page_no + 1).join(',')} 페이지를 확인하세요.`}
            </Title>
          ),
        });
      } else {
        window.localStorage.removeItem(`PASSAGE_${code}_${userData.user_idx}`);
        const cSttText = Object.values(currentSttText.current);
        const accuracy = parseInt(cSttText.reduce((p, t) => p + t.accuracy, 0) / cSttText.length);
        const wpm = parseInt(cSttText.reduce((p, t) => p + t.wpm, 0) / cSttText.length);
        Modal.destroyAll();
        Modal.info({
          icon: null,
          title: 'Done',
          content: <Title level={4}>{`  당신의 점수는 ${accuracy} 점 입니다. 학습을 종료합니다.`}</Title>,
          onOk: () => {
            onClickGoback(
              {
                exam_total: 100,
                exam_correct: accuracy,
                message: `당신의 점수는 ${accuracy} 점 입니다. 학습을 종료합니다.`,
                exitMessage: `학습을 종료하시겠습니까?`,
                recording_data: cSttText.map((e) => `<p>${e.text}</p>`).join(''),
                wpm,
              },
              true,
            );
            setProcessCallbackLoading([]);
            currentSttText.current = [];
          },
        });
      }
    }
  };
  const word_count = dataNew.length > 0 ? dataNew[currentPage]['text'].split(' ').length : 0;

  if (dataNew.length == 0) {
    return '';
  }
  const handleCloseClick = () => {
    Modal.confirm({
      icon: null,
      title: 'Exit',
      content: (
        <Title level={4} style={{ textAlign: 'center', lineHeight: 2 }}>
          학습이 완료되지 않았습니다. <br /> 종료하면 지금 학습하는 Stage를 <br />
          처음부터 다시 해야 합니다. <br /> 종료 하시겠습니까?
        </Title>
      ),
      onOk: () => history.push('/'),
    });
  };
  return (
    <>
      <HeaderWrapper
        style={{
          background: '#fff',
          paddingLeft: 10,
          paddingRight: 10,
          display: 'flex',
          justifyContent: 'space-between',
          position: 'relative',
          width: '100%',
          height: isMobileOnly && 50,
          lineHeight: isMobileOnly && '50px',
        }}
      >
        <div style={{ paddingTop: 10 }}>
          <Title level={2} style={{ marginLeft: 20, textTransform: 'capitalize', fontSize: isMobileOnly && 20 }}>
            Recording
          </Title>
        </div>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {isMobileOnly && (
            <div style={{ backgroundColor: '' }}>
              <FullScreenButton
                element={<ImgButton className="header-btn" src="/images/fullscreen_blue.png" alt="back arrow in header" />}
                activeElement={<ImgButton className="header-btn" src="/images/fullscreenExit_blue.png" alt="back arrow in header" />}
              />
            </div>
          )}
          <div key="close" onClick={handleCloseClick}>
            <span style={{ color: '#999', cursor: 'pointer' }}>
              <CloseCircleOutlined
                style={{
                  marginRight: 20,
                  verticalAlign: 'middle',
                  fontSize: 25,
                  color: '#424242',
                }}
                key="close"
              />
            </span>
          </div>
        </div>
      </HeaderWrapper>
      <Col className="quiz-fluid-container" span={24} style={{ textAlign: 'left', margin: 0 }}>
        <MainBlock className="quiz-fluid-scroll">
          {showModal ? (
            <div
              style={{
                display: 'flex',
                height: '90%',
                fontWeight: 600,
                color: '#2F2725',
                margin: `0 ${width < 0.8 ? 10 : 55 * width}px 80px`,
              }}
            >
              <div style={{ flex: 1, marginRight: 40, height: '80%' }}>
                <ResultHead>
                  <Title level={3} style={{ textAlign: 'center', margin: 0 }}>
                    Content
                  </Title>
                </ResultHead>
                <ResultBody>
                  <Editor
                    editorState={text}
                    editorStyle={{
                      width: '100%',
                      height: 'calc(100% - 20px)',
                      // minHeight: `${height * 450}px`,
                      // backgroundColor: "beige",
                      padding: '10px 20px',
                      fontSize: '18px',
                    }}
                    toolbarClassName="hide-print"
                    wrapperClassName="essay-wrapper"
                    editorClassName="essay-editor"
                    readOnly={true}
                    toolbarHidden
                  />
                </ResultBody>
                <RowFlex
                  style={{
                    fontSize: `${24 * width}px`,
                    fontFamily: 'Noto Sans KR',
                    fontWeight: 'bold',
                    justifyContent: 'center',
                    marginTop: 15,
                  }}
                >
                  <div style={{ padding: '0 15px' }}>
                    Extra text is <span style={{ color: '#1781FF' }}> blue.</span>
                  </div>
                  <div style={{ padding: '0 15px' }}>
                    Missed text is <span style={{ color: '#E91D00' }}>red.</span>
                  </div>
                </RowFlex>
              </div>
              <div style={{ flex: 1, fontWeight: 600, color: '#2F2725', height: '80%' }}>
                <ResultHead>
                  <Title level={3} style={{ textAlign: 'center', margin: 0 }}>
                    Your Response
                  </Title>
                </ResultHead>
                <ResultBody>
                  <Editor
                    editorState={textRest}
                    rootStyle={{ backgroundColor: '#93babb' }}
                    editorStyle={{
                      width: '100%',
                      height: 'calc(100% - 20px)',
                      // minHeight: `${height * 450}px`,
                      // backgroundColor: "#93babb",
                      padding: '10px 20px',
                      fontSize: '18px',
                    }}
                    style={{ backgroundColor: '#93babb' }}
                    toolbarClassName="hide-print"
                    wrapperClassName="essay-wrapper"
                    editorClassName="essay-editor"
                    readOnly={true}
                    toolbarHidden
                  />
                </ResultBody>
                <RowFlex
                  style={{
                    fontSize: `${24 * width}px`,
                    fontFamily: 'Noto Sans KR',
                    fontWeight: 'bold',
                    justifyContent: 'center',
                    alignItems: 'center',
                    marginTop: 15,
                  }}
                >
                  <div style={{ padding: '0 1px' }}>
                    Accuracy{' '}
                    <button
                      style={{
                        color: '#6A40BA',
                        height: `${44 * height}px`,
                        width: `${87 * width}px`,
                        border: '1px solid #9e9f9f',
                        borderRadius: '5px',
                        backgroundColor: '#fff',
                      }}
                    >
                      {currentDoneValue && currentDoneValue.accuracy ? parseInt(currentDoneValue.accuracy) : '0'}%
                    </button>
                  </div>
                  <div style={{ padding: '0 15px' }}>
                    WPM{' '}
                    <button
                      style={{
                        color: '#F49140',
                        height: `${44 * height}px`,
                        width: `${87 * width}px`,
                        border: '1px solid #9e9f9f',
                        borderRadius: '5px',
                        backgroundColor: '#fff',
                      }}
                    >
                      {currentDoneValue && currentDoneValue.wpm ? parseInt(currentDoneValue.wpm) : '0'}
                    </button>
                  </div>
                  <Button
                    style={{
                      // backgroundColor: 'transparent',
                      // backgroundImage: 'url(/images/creo/esl/button/record_done.png)',
                      height: `${45 * height}px`,
                      width: `${110 * width}px`,
                      backgroundRepeat: 'no-repeat',
                      backgroundSize: 'contain',
                      fontSize: `${20 * width}px`,
                    }}
                    type="danger"
                    onClick={() => {
                      setShowModal(false);
                      hideHeader(false);
                    }}
                  >
                    Go Back
                  </Button>
                </RowFlex>
              </div>
            </div>
          ) : (
            <ColumnFlex style={{ height: '100%' }}>
              <Row gutter={[24, 16]} style={{ padding: 10 }}>
                <Col className="quiz-heading" span={16}>
                  <Row gutter={[24, 16]} style={{ margin: 0 }}>
                    <Col className="quiz-heading-containt" span={24} style={{ padding: 10, paddingLeft: 10 }}>
                      <Title level={2} ellipsis>
                        <span style={{ color: '#065aa9', marginLeft: 10, fontSize: isMobileOnly && '16px' }}>
                          Click the recording button and read the passage.
                        </span>{' '}
                      </Title>
                    </Col>
                  </Row>
                </Col>
                <Col
                  className="quiz-heading-listing"
                  span={8}
                  style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', paddingRight: 10 }}
                ></Col>
              </Row>
              <RowFlex style={{ margin: width < 0.95 && '0 15px', justifyContent: 'space-around', flex: 1 }}>
                <div style={{ width: '68%' }}>
                  <div
                    style={{
                      border: `2px solid #c0daf1`,
                      borderRadius: '10px',
                      padding: `${height * 25}px ${width * 25}px`,
                      maxHeight: 450 * height * (height <= 0.91 ? 0.9 : 1) + 'px',
                      overflowY: 'auto',
                      minHeight: 450 * height * (height <= 0.91 ? 0.9 : 1) + 'px',
                    }}
                    className="text-content"
                  >
                    <p
                      style={{ fontSize: height < 0.8 || width < 0.8 ? '17px' : '24px' }}
                      dangerouslySetInnerHTML={{
                        __html: dataNew.length > 0 ? dataNew[currentPage]['text_tmp']?.replace(/\n/g, '<br/>') : '',
                      }}
                    ></p>
                  </div>
                  <div
                    className="pagination"
                    style={{
                      alignItems: 'center',
                      border: '2px solid #d5e4ff',
                      borderRadius: '32px',
                      display: 'flex',
                      flexDirection: 'row',
                      height: '63px',
                      justifyContent: 'center',
                      marginTop: '2%',
                      padding: '0 15px',
                      width: '100%',
                      transform: `scale(${Math.min(width, height)})`,
                      transformOrigin: 'top',
                    }}
                  >
                    {/* <button
                      style={{
                        background: 'url(/images/arrow_1.png)',
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: 'cover',
                        display: 'flex',
                        height: '34px',
                        position: 'relative',
                        transform: 'translateX(0)',
                        transition: 'transform .3s ease',
                        width: '40px',
                        border: 'none',
                      }}
                      className={`pagination-left ${isRecording ? 'disabled' : ''}`}
                      disabled={isRecording}
                      onClick={() => pageMove(currentPage ? currentPage - 1 : 0)}
                    ></button> */}
                    <NumberList length={dataNew ? (dataNew.length > 5 ? 5 : dataNew.length) : 1}>
                      {dataNew
                        .filter((e, i) => Math.floor(i / 5) === Math.floor(currentPage / 5))
                        .map((e, i) => (
                          <PageNumber
                            key={i}
                            active={i === currentPage}
                            onClick={() => {
                              if (!isRecording) {
                                pageMove(i);
                              }
                            }}
                          >
                            {i + 1}
                          </PageNumber>
                        ))}
                    </NumberList>
                    {/* <button
                      style={{
                        background: 'url(/images/arrow_2.png)',
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: 'cover',
                        display: 'flex',
                        height: '34px',
                        position: 'relative',
                        transform: 'translateX(0)',
                        transition: 'transform .3s ease',
                        width: '40px',
                        border: 'none',
                      }}
                      className={`pagination-right ${isRecording ? 'disabled' : ''}`}
                      disabled={isRecording}
                      onClick={() => pageMove(currentPage < totalPage - 1 ? currentPage + 1 : currentPage)}
                    ></button> */}
                  </div>
                </div>
                <div style={{ width: '28%' }}>
                  {processCallbackLoading[currentPage] ? (
                    <div
                      style={{
                        padding: `${height * 25} ${width * 25} ${height * 25} ${width * 25}`,
                        backgroundColor: '#d5e4ff',
                        borderRadius: '10px',
                      }}
                    >
                      <Spin
                        size="large"
                        style={{
                          height: 450 * height * (height <= 0.91 ? 0.9 : 1) + 'px',
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontSize: '100px',
                        }}
                      />
                    </div>
                  ) : (
                    <div
                      // className="textcontent-recordingcreo-middlebox"
                      style={{
                        height: 450 * height * (height <= 0.91 ? 0.9 : 1) + 'px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        border: '2px solid #c0daf1',
                        borderRadius: '10px',
                        justifyContent: 'center',
                        // padding: `${height * 25}px ${width * 25}px`,
                      }}
                    >
                      <div
                        // className="textcontent-recordingcreo-title"
                        style={{
                          fontSize: `${Math.min(height, width) * 26}px`,
                          marginBottom: height * (height <= 0.91 ? 0.7 : 1) * 25,
                        }}
                      >
                        WPM / Accuracy
                      </div>
                      <div
                        className="count-one"
                        style={{
                          width: width * 340,
                          height: height * 190,
                          margin: '0 0 10px 0',
                          padding: `${height * 20}px ${width * 40}px ${height * 20}px ${width * 30}px`,
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'space-between',
                        }}
                      >
                        <RowFlex className="count-one-a countone" style={{ justifyContent: 'space-between' }}>
                          <div className="count-one-text" style={{ color: '#7C2C83', fontSize: Math.min(width, height) * 24 }}>
                            Word {width > 0.8 && 'Count'}
                          </div>
                          <div style={{ textAlign: 'center' }} className="count-one-input purple-number">
                            <div
                              style={{
                                width: Math.min(width, height) * 90,
                                height: Math.min(width, height) * 41.7,
                                fontSize: Math.min(width, height) * 24,
                                border: '2px solid #9e9f9f',
                                borderRadius: '5px',
                              }}
                            >
                              {word_count}
                            </div>
                          </div>
                        </RowFlex>
                        <RowFlex
                          className="count-one-b countone"
                          style={{ justifyContent: 'space-between', fontSize: Math.min(width, height) * 24 }}
                        >
                          <div className="count-one-text" style={{ fontSize: Math.min(width, height) * 24 }}>
                            {width > 0.8 && 'My '}WPM
                          </div>
                          <div
                            style={{ textAlign: 'center' }}
                            // className={`count-one-input ${
                            //   currentDoneValue && currentDoneValue.wpm > WPM_GOAL[lessonLevel]
                            //     ? "green-number"
                            //     : "red-number"
                            // }`}
                          >
                            {currentDoneValue ? (
                              <div
                                style={{
                                  width: Math.min(width, height) * 90,
                                  height: Math.min(width, height) * 41.7,
                                  fontSize: Math.min(width, height) * 24,
                                  border: '2px solid #9e9f9f',
                                  borderRadius: '5px',
                                }}
                              >
                                {parseInt(currentDoneValue.wpm)}
                              </div>
                            ) : (
                              <div
                                style={{
                                  width: Math.min(width, height) * 90,
                                  height: Math.min(width, height) * 41.7,
                                  fontSize: Math.min(width, height) * 24,
                                  border: '2px solid #9e9f9f',
                                  borderRadius: '5px',
                                }}
                              >
                                &nbsp;
                              </div>
                            )}
                          </div>
                        </RowFlex>
                        <RowFlex
                          className="count-one-c countone"
                          style={{ fontSize: Math.min(width, height) * 24, justifyContent: 'space-between' }}
                        >
                          <div className="count-one-text" style={{ fontSize: Math.min(width, height) * 24 }}>
                            Acc{width <= 0.8 ? '.' : 'uracy'}
                          </div>
                          <div
                            style={{ textAlign: 'center' }}
                            className={`count-one-input ${
                              currentDoneValue && currentDoneValue.accuracy > 80 ? 'green-number' : 'red-number'
                            }`}
                          >
                            {currentDoneValue ? (
                              <div
                                style={{
                                  width: Math.min(width, height) * 90,
                                  height: Math.min(width, height) * 41.7,
                                  fontSize: Math.min(width, height) * 24,
                                  border: '2px solid #9e9f9f',
                                  borderRadius: '5px',
                                }}
                              >
                                {parseInt(currentDoneValue.accuracy)}
                              </div>
                            ) : (
                              <div
                                style={{
                                  width: Math.min(width, height) * 90,
                                  height: Math.min(width, height) * 41.7,
                                  fontSize: Math.min(width, height) * 24,
                                  border: '2px solid #9e9f9f',
                                  borderRadius: '5px',
                                }}
                              >
                                &nbsp;
                              </div>
                            )}
                          </div>
                        </RowFlex>
                      </div>

                      {/* <div
                        className="count-bar"
                        style={{
                          transform: `scale(${Math.min(height, width) * (height <= 0.91 ? 0.9 : 1)})`,
                          transformOrigin: 'top',
                          margin: 0,
                        }}
                      >
                        <input type="range" className="slider" min={0} max={100} step={1} value={currentProgressSlider} />
                      </div> */}
                      <div
                        className="count-buttons"
                        style={{
                          transform: `scale(${Math.min(height, width) * (height <= 0.91 ? 0.9 : 1)})`,
                          transformOrigin: 'top',
                          margin: `${height < 0.55 ? '-5' : '10'}px 0 0 0`,
                          width: '300px',
                          display: 'flex',
                          justifyContent: 'space-between',
                        }}
                      >
                        {/* <button className="btn-a" onClick={() => setPlaying(false)}></button> */}
                        <Buttons
                          url={`/images/record.png`}
                          isBlink={isRecording}
                          className={` ${isRecording ? 'blink_dark_creo' : ''}`}
                          onClick={() => {
                            if (isRecording) {
                              const activeRecorder = recordAudio.current?.[currentPage] || recordAudio.current?.[lastPage];
                              message.info(activeRecorder ? '녹음을 처리하고 있습니다.' : '녹음 시작이 취소되었습니다. 다시 시도해주세요.');
                            }
                            setIsRecording((recording) => !recording);
                          }}
                        ></Buttons>
                        <Buttons
                          // className="btn-c"
                          isgray={!lastBlob}
                          url={`/images/${playing ? 'pause' : 'play_record'}.png`}
                          onClick={() => {
                            if (lastBlob) {
                              setPlaying((prev) => !prev);
                            }
                          }}
                        ></Buttons>
                        <Buttons
                          isgray={!currentDoneValue}
                          disabled={processCallbackLoading[currentPage]}
                          // className="btnresult"
                          // style={{ backgroundImage: `url(/images/creo/esl/button/record_result.png)` }}
                          url={`/images/result.png`}
                          onClick={openModel}
                        ></Buttons>
                        <Buttons
                          isgray={
                            recordingData
                              .filter((p) => p.text)
                              .filter(
                                (r) =>
                                  !Object.keys(currentSttText.current)
                                    .map((p) => parseInt(p))
                                    .includes(r.page_no),
                              ).length
                          }
                          url={`/images/upload.png`}
                          // className="btn-d"
                          onClick={handleUploadClick}
                        ></Buttons>
                      </div>
                    </div>
                  )}

                  <div
                    className="resultwithtext"
                    style={{
                      transform: `scale(${Math.min(width, height)})`,
                      transformOrigin: 'top',
                      marginTop: '7%',
                      display: 'flex',
                      justifyContent: 'center',
                    }}
                  >
                    <RowFlex style={{ alignItems: 'end', height: '100%' }}>
                      {/* <Button
                        type="primary"
                        size="large"
                        disabled={processCallbackLoading[currentPage]}
                        // className="btnresult"
                        // style={{ backgroundImage: `url(/images/creo/esl/button/record_result.png)` }}
                        onClick={openModel}
                      >
                        Result
                      </Button> */}
                      {processCallbackLoading[currentPage] ? (
                        <Spin
                          size="large"
                          indicator={antIcon}
                          style={{
                            position: 'absolute',
                            background: '#6A40BA',
                            width: '120px',
                            height: '48px',
                            borderRadius: '24px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        />
                      ) : null}
                      &nbsp;&nbsp;{' '}
                      <RowFlex
                        style={{
                          alignItems: 'center',
                          height: '100%',
                          fontSize: `${height < 0.55 ? 20 : 24}px`,
                          color: '#595757',
                          fontFamily: 'Noto Sans KR',
                          fontWeight: 'bold',
                          marginLeft: '10px',
                        }}
                      >
                        {`After ${parseInt((word_count * 3) / 10)} seconds`}
                      </RowFlex>
                    </RowFlex>
                  </div>
                </div>
              </RowFlex>
            </ColumnFlex>
          )}
          {playing ? (
            <ReactPlayer
              controls
              width={0}
              height={0}
              url={lastBlob}
              loop={false}
              playing={playing}
              onEnded={() => setPlaying(false)}
              onError={() => setPlaying(false)}
              onProgress={(progress) => {
                setCurrentProgressSlider((progress.playedSeconds / progress.loadedSeconds) * 100);
              }}
            />
          ) : null}
        </MainBlock>
      </Col>
    </>
  );
};

export default WpmPage;
const useCheckScreen = () => {
  const [width, setWidth] = useState(window.innerWidth);
  const [height, setHeight] = useState(window.innerHeight);
  const handleWindowSizeChange = () => {
    setHeight(window.innerHeight);
    setWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    };
  }, []);

  return [width > 1600 ? 1 : width / 1600, height / 900];
};
const ColumnFlex = styled.div`
  display: flex;
  flex-direction: column;
`;
const RowFlex = styled.div`
  display: flex;
  flex-direction: row;
`;
const NumberList = styled(RowFlex)`
  width: ${(props) => props.length * 75 + 'px'};
  justify-content: space-evenly;
  align-items: center;
`;

const PageNumber = styled(ColumnFlex)`
  width: 46px;
  height: 46px;
  /* line-height: 63px; */
  font-size: 21px;
  font-weight: bold;
  color: ${(props) => (!props.active ? '#3b6c9c' : '#fff')};
  background: ${(props) => (props.active ? '#3b6c9c' : '#fff')};
  border: 2px solid ${(props) => (!props.active ? '#3b6c9c' : '#fff')};
  border-radius: 23px;
  text-align: center;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  /* @media (max-height: 960px) {
    font-size: 25px;
    line-height: 50px;
    width: 50px;
    height: 50px;
    border-radius: 25px;
  } */
`;
const blink = keyframes`
  0% {
    filter: grayscale(0%);
    opacity: 1;
  }
  50% {
    filter: grayscale(50%);
    opacity: 0.5;
  }
  100% {
    filter: grayscale(90%);
    opacity: 0.1;
  }
`;
const Buttons = styled.button`
  background-repeat: no-repeat;
  background-size: scale-down;
  width: 68px;
  height: 72px;
  background-color: transparent;
  background-image: url(${(props) => props.url});
  background-position: center;
  background-size: contain;
  border: none;
  filter: ${(props) => (props.isgray ? 'grayscale(90%)' : 'none')};
  ${({ isBlink }) =>
    isBlink &&
    css`
      animation: ${blink} 1.5s infinite;
    `}
`;

const ResultHead = styled(RowFlex)`
  border-radius: 22px 22px 0 0;
  align-items: center;
  justify-content: center;
  height: 50px;
  margin-bottom: 10px;
  border: 2px solid #c0daf1;
`;
const ResultBody = styled.div`
  background-color: #fff;
  border-radius: 0 0 15px 15px;
  height: 100%;
  overflow: auto;
  border: 2px solid #c0daf1;
`;
